import { render, staticRenderFns } from "./tiscTab.vue?vue&type=template&id=132016b0&"
import script from "./tiscTab.vue?vue&type=script&lang=js&"
export * from "./tiscTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports